import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject,map } from 'rxjs';
import { filter } from 'rxjs/operators';
import { _isNil } from '@core/lodash/lodash';

export interface EventsManagerSubscription {
	eventName: string;
	callback: any;
}

export interface EventManagerEvent {
	eventName: string;
	argument?: any;
}

@Injectable({
	providedIn: 'root',
})
export class EventsManagerService {

	private eventSubject = new Subject<EventManagerEvent>();
	private subscribedEventNames = [];

	constructor(
		private router: Router,
		private ngZone: NgZone,
	) { }

	publish<T>(eventName: string, argument?: T) {
		window.eventsManager.publish(eventName, argument);
	}

	async hideContainerAndPublish<T>(eventName: string, argument?: T) {
		await this.router.navigateByUrl('/legacy');
		this.publish(eventName, argument);
	}

	subscribe(eventName: string, callback: (event: EventManagerEvent) => void, context?: any): EventsManagerSubscription {
		window.eventsManager.subscribe(eventName, callback, context);
		return {
			eventName,
			callback,
		};
	}

	subscribeObservable(eventName: string): Observable<EventManagerEvent> {
		if (!this.subscribedEventNames.includes(eventName)) {
			this.subscribe(eventName, event => this.ngZone.run(() => this.eventSubject.next(event)), null);
			this.subscribedEventNames.push(eventName);
		}
		return this.eventSubject.pipe(filter(event => event.eventName === eventName));
	}

	subscribeObservableArgument(eventName: string): Observable<any> {
		return this.subscribeObservable(eventName).pipe(map(event => event.argument));
	}

	unsubscribe(eventName: string, callback: (any)) {
		window.eventsManager.unsubscribe(eventName, callback);
	}

	unsubscribeEvent(event: EventsManagerSubscription) {
		if (event && event.eventName && event.callback) {
			this.unsubscribe(event.eventName, event.callback);
		}
	}

	subscribePatientObservable(eventName: string, patientId: number): Observable<EventManagerEvent> {
		return this.subscribeObservable(eventName).pipe(
			filter(event => _isNil(event?.argument?.patientId) || event?.argument?.patientId === patientId),
		);
	}
}
